import request from "./request";
//获取报告信息
export function getReportMessage(id) {
  return request(`/page-data/${id}`, "GET");
}
export function getTaskOrderMessage(id) {
  return request(`/page-data/task-order/${id}`, "GET");
}
